// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__w3E9l","tableRow":"styles_tableRow__ZU5n-","noData":"styles_noData__OZRqx","dayName":"styles_dayName__naSoH","theme":"styles_theme__ngW8A"};